import client from './client';

export const reportBug = (bugReport) => {
  return client.post('/api/bug-reports', bugReport);
};
